import { render, staticRenderFns } from "./NuevoPaciente.vue?vue&type=template&id=72bcd00a&scoped=true&"
import script from "./NuevoPaciente.vue?vue&type=script&lang=ts&"
export * from "./NuevoPaciente.vue?vue&type=script&lang=ts&"
import style0 from "./NuevoPaciente.vue?vue&type=style&index=0&id=72bcd00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bcd00a",
  null
  
)

export default component.exports